export const ITEMS_UNTIL_LOAD_MORE = 8; // Number of items remaining before triggering load more
export const LOAD_MORE_THRESHOLD = 200;
export const LOAD_MORE_CALLBACK_LIMIT_TIME = 1000;
export const PADDING_BOTTOM = '24px';
export const PADDING_BETWEEN = '12px';
export const NAVBAR_PADDING = 60;
